const listItem = {
    EditorElement: props => {
        const { attributes, children, element } = props;
        return <li {...attributes}>{children}</li>;
    },
    PreviewElement: ({ attributes, children }) => {
        return <li {...attributes}>{children}</li>;
    },
};

export default listItem;
